<div style="text-align: center;background-color: blue;color: white;padding: 10px;display: flex;justify-content: space-between;align-items: center;margin: -20px -20px 20px -20px;">
    <span>{{data.title}}</span>
    <button (click)="onClose()" style="background: none;border: none;color: white;font-size: 20px;cursor: pointer;">
        <i class="fas fa-times"></i>
    </button>
</div>
<table>
    <tr>
        <th style="padding-left: 10px !important;">Name : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.userName" name="userName" />
        </th>
    </tr>

    <tr>
        <th style="padding-left: 10px !important;">Mobile No : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.mobileNo" name="mobileNo" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Email/User Id : </th>
        <th>
            <input type="email" [(ngModel)]="data.model.emailId" name="emailId" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Password : </th>
        <th>
            <input type="password" [(ngModel)]="data.model.password" name="password" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">User Type : </th>
        <th>
            <select [(ngModel)]="data.model.userType" name="userType">
                <option value="0">Select</option>
                <option value="Admin">Admin</option>
                <option value="Counsellor">Counsellor</option>
                <option value="Third Party">Third Party</option>
            </select>
        </th>
    </tr>

    <tr>
        <th style="padding-left: 10px !important;">Valid Till Date : </th>
        <th>
            <input type="date" placeholder="Valid Till Date" [(ngModel)]="data.model.tillDate" name="tillDate">
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Show Me Leads Before : </th>
        <th>
            <input type="text" size="3" placeholder="Show me Leads Before " [(ngModel)]="data.model.showMeUpcomingEventsOf" name="showMeUpcomingEventsOf">Days
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Status</th>
        <th>
            <select [(ngModel)]="data.model.currentStatus" name="currentStatus">
                <option value="0" disabled>Select</option>
                <option value="Active">Active</option>
                <option value="In active">In active</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Access Source</th>
        <th>
            <select [(ngModel)]="data.model.accessSource" name="accessSource">
                <option value="0" disabled>Select</option>
                <option value="All">All</option>
                <option *ngFor="let item of data.leadSources| async;let counter=index;" value="{{item.sourceName}}">{{item.sourceName}}</option>

            </select>
        </th>
    </tr>
</table>
<br />
<button class="btn btn-sm btn-primary" (click)="onSave();" style="float: inline-end;">
    <i class="fas fa-plus"></i> Save
</button>